/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Container, CssBaseline, Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../assets/styles/pages/Shops';
import Header from '../../../components/Header';
import FooterMenuMain from '../../../components/FooterMenuMain';

import MainShop from '../../../components/MainShop';

// import svg
import { ReactComponent as IconStarBold } from '../../../assets/images/svg/shops/icon_star_bold.svg';
import { ReactComponent as IconStarLinear } from '../../../assets/images/svg/shops/icon_star_linear.svg';
import { ReactComponent as IconUser } from '../../../assets/images/svg/user/icon_user.svg';

import { api } from '../../../services';
import { ItypeReturnApi } from '../../../helpers/utils/TypeReturnApi';
import { useLoadingContext } from '../../../providers/use-loading';
import { FormatPrice } from '../../../helpers/utils/Formating';

const RatingShop: React.FC = () => {
  const classeStyle = useStyles();
  const { idRestaurante }: any = useParams();
  const { createloading } = useLoadingContext();

  const [ratings, setRatings] = useState<any>();

  const getRatings = async () => {
    createloading(true);
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.shop.getRating({
        nr_operacao: 22,
        TipoRetorno: 2,
        idRestaurante: window.atob(idRestaurante),
      });

      setRatings(result.data);
      createloading(false);
    } catch (error) {
      createloading(false);
      toast.error('Ocorreu um erro ao bucsar as avaliações');
    }
  };

  useEffect(() => {
    getRatings();
  }, []);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Shops" />
      <CssBaseline />
      <MainShop />
      {ratings?.avaliacao?.qtAvaliacoes > 0 && (
        <>
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <Grid className={classeStyle.gridRatingMain}>
              <Grid className={classeStyle.gridRating}>
                <p className={classeStyle.textRating}>Produto:</p>
                <IconStarBold style={{ marginRight: 5 }} />
                <p
                  className={classeStyle.textRating}
                  style={{ fontWeight: 700, color: '#ff8a00' }}
                >
                  {FormatPrice(ratings.avaliacao.vlQualidade)}
                </p>
              </Grid>
              <p className={classeStyle.textSeparator}>l</p>
              <Grid className={classeStyle.gridRating}>
                <p className={classeStyle.textRating}>Entrega:</p>
                <IconStarBold style={{ marginRight: 5 }} />
                <p
                  className={classeStyle.textRating}
                  style={{ fontWeight: 700, color: '#ff8a00' }}
                >
                  {FormatPrice(ratings.avaliacao.vlRapidez)}
                </p>
              </Grid>
              <p className={classeStyle.textSeparator}>l</p>
              <Grid className={classeStyle.gridRating}>
                <p className={classeStyle.textRatingBold}>
                  {ratings.avaliacao.qtAvaliacoes} Avaliações
                </p>
              </Grid>
            </Grid>
            <Grid className={classeStyle.lineRating} />
          </Grid>
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            marginBottom="100px"
          >
            {ratings.comentarios.length > 0 &&
              ratings.comentarios.map((commentData: any) => (
                <Grid
                  key={commentData.idAvaliacao}
                  className={classeStyle.gridComment}
                >
                  <Grid container item>
                    <Grid container item xs={1}>
                      <IconUser width={30} height={30} />
                    </Grid>
                    <Grid item xs={11}>
                      <h5 className={classeStyle.textNameComment}>
                        {commentData.dsNome} - {commentData.dtAvaliacao}
                      </h5>
                      <p className={classeStyle.textDesComment}>
                        {commentData.dsComentario}
                      </p>
                      {commentData?.dsResposta && (
                        <Grid className={classeStyle.gridResponse}>
                          <p className={classeStyle.titleResponse}>Resposta</p>
                          <p className={classeStyle.textDesComment}>
                            {commentData.dsResposta}
                          </p>
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                  <Grid className={classeStyle.gridStarComment}>
                    <IconStarLinear />
                    <p className={classeStyle.textNoteComment}>
                      {FormatPrice(commentData.vlMedia)}
                    </p>
                  </Grid>
                </Grid>
              ))}
          </Grid>
        </>
      )}
      <FooterMenuMain />
    </Container>
  );
};

export default RatingShop;
